const ROOT_SELECTOR = '[data-premium-reveal]';
const ITEM_CLASS = 'premium-reveal__item';
const ROOT_VISIBLE_CLASS = 'is-premium-visible';

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let observer;

function uniqueElements(elements) {
  return [...new Set(elements.filter((element) => element instanceof HTMLElement))];
}

function getRevealItems(root) {
  const explicitItems = uniqueElements([...root.querySelectorAll('[data-premium-reveal-item]')]);
  if (explicitItems.length > 0) return explicitItems;

  const revealType = root.dataset.premiumReveal;

  if (revealType === 'hero') {
    return uniqueElements([
      root.querySelector(':scope > .hero__media-grid'),
      ...root.querySelectorAll(':scope > .hero__content-wrapper > *'),
    ]);
  }

  if (revealType === 'split') {
    return uniqueElements([
      ...root.querySelectorAll(':scope > .media-block, :scope > .media-with-content__content'),
    ]);
  }

  if (revealType === 'footer') {
    return uniqueElements([...root.querySelectorAll('.home-footer > *')]);
  }

  const contentWrapper = root.querySelector('.section-content-wrapper');
  if (contentWrapper) {
    return uniqueElements([...contentWrapper.children]);
  }

  return [root];
}

function reveal(root) {
  root.classList.add(ROOT_VISIBLE_CLASS);
  observer?.unobserve(root);
}

function prepareRoot(root) {
  if (!(root instanceof HTMLElement) || root.dataset.premiumRevealReady === 'true') return;

  const items = getRevealItems(root);
  const visibleItems = items.filter((item) => !item.hasAttribute('hidden'));

  visibleItems.forEach((item, index) => {
    item.classList.add(ITEM_CLASS);
    item.style.setProperty('--premium-reveal-delay', `${Math.min(index * 120, 480)}ms`);
  });

  root.dataset.premiumRevealReady = 'true';

  if (prefersReducedMotion.matches) {
    reveal(root);
    return;
  }

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -10% 0px',
      }
    );
  }

  observer.observe(root);
}

function initializePremiumReveal(scope = document) {
  scope.querySelectorAll(ROOT_SELECTOR).forEach(prepareRoot);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePremiumReveal(), { once: true });
} else {
  initializePremiumReveal();
}

document.addEventListener('shopify:section:load', (event) => {
  initializePremiumReveal(event.target);
});

window.addEventListener('pageshow', () => {
  initializePremiumReveal();
});
